import { useMemo } from 'react';
import { useWorkspace } from '../../../app/WorkspaceContext';

const DESIGNER_ROLES = new Set(['OWNER', 'ADMIN']);

export const useCatalogTemplateDesigner = () => {
  const { currentWorkspace } = useWorkspace();
  return useMemo(() => {
    const role = String(currentWorkspace?.role || '').toUpperCase();
    return DESIGNER_ROLES.has(role);
  }, [currentWorkspace?.role]);
};

export default useCatalogTemplateDesigner;
